import { render, staticRenderFns } from "./PointSource.vue?vue&type=template&id=0abb4b4f&scoped=true&"
import script from "./PointSource.vue?vue&type=script&lang=js&"
export * from "./PointSource.vue?vue&type=script&lang=js&"
import style0 from "./PointSource.vue?vue&type=style&index=0&id=0abb4b4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abb4b4f",
  null
  
)

export default component.exports